import type { SnapshotCaptureResult } from '@peritasai/types';

/**
 * Domain entity for a captured camera snapshot. Wraps the normalized `/snapshot`
 * result and exposes whether a backend storage key is available (drives whether
 * the frame can be persisted to the completion record vs. shown locally only).
 */
export class CameraSnapshotEntity {
  /** Displayable image URL (a service URL or a blob object URL). */
  readonly previewUrl: string;
  /** Backend storage key, when the service returned one. */
  readonly storageKey: string | null;

  constructor(result: SnapshotCaptureResult) {
    this.previewUrl = result.previewUrl;
    this.storageKey = result.storageKey;
  }

  /** Whether this snapshot can be persisted to the backend completion record. */
  get hasStorageKey(): boolean {
    return this.storageKey !== null;
  }
}
